import React from 'react'
import styled from 'styled-components'
import { withPrefix } from 'gatsby'
import { Accordion, AccordionItem } from 'react-sanfona'
import Obfuscate from 'react-obfuscate'
import PageTitle from '../components/PageTitle'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'

const Staff2 = props => {
  const staff = props.data.allStaffJson.edges.map(e => ({
    ...e.node,
  }))

  return (
    <Layout>
      <PageTitle
        name="Staff"
        site="OIRA"
        description="Staff of the Office of Institutional Research and Assessment at The University of Alabama"
      />
      <Accordion activeItems={0}>
        {staff.map((link, i) => (
          <AccordionUnit
            key={i}
            title={
              <div>
                {link.name} <Title> {link.title} </Title>
              </div>
            }
          >
            <div>
              <Img
                src={withPrefix(
                  `/staff-images/${link.image || 'Placeholder_no_text.svg'}`
                )}
                alt={`${link.name} staff photo`}
              />
              <Contact>
                <p>
                  Office: {link.office}
                  <br />
                  Phone: <Obfuscate tel={link.phone || ' '} />
                  <br />
                  Fax: <Obfuscate tel={link.fax || ' '} />
                  <br />
                  Email: <Obfuscate email={link.email || ' '} />
                </p>
              </Contact>
              <Education>
                <p>
                  {[link.education1, link.education2, link.education3, link.education4].map((edu, idx) =>
                    edu
                      ? edu.split('\n').map((line, i) => (
                          <React.Fragment key={`${idx}-${i}`}>
                            {line}
                            <br />
                          </React.Fragment>
                        ))
                      : null
                  )}
                </p>
              </Education>
            </div>
          </AccordionUnit>
        ))}
      </Accordion>
    </Layout>
  )
}

const Img = styled.img`
  float: left;
  width: 100px;
  margin: 1em 1em 1em 0em;
`
const Contact = styled.div`
  float: left;
  margin: 1em;
`
const Education = styled.div`
  text-align: right;
  float: right;
  margin: 1em 0em 1em 1em;
  max-width: 500px;
  @media (max-width: 800px) {
    text-align: left;
    float: left;
  }
`
const Title = styled.span`
  float: right;
  color: #990000;
  @media (max-width: 800px) {
    float: none;
    display: block;
  }
`
const AccordionUnit = styled(AccordionItem)`
  border-bottom: 1px solid hsla(0, 0%, 0%, 0.2);
  padding-bottom: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
`
export const query = graphql`
  query imagesAndStaff {
    allFile(filter: { extension: { eq: "jpg" } }) {
      edges {
        node {
          name
        }
      }
    }
    allStaffJson {
      edges {
        node {
          name
          title
          office
          phone
          fax
          email
          education1
          education2
          education3
          education4
          image
        }
      }
    }
  }
`
export default Staff2
